import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import type { PageSize } from '@platform/core/types';
import type { IViewSortEditorProps } from './IViewSortEditorProps';

const SIZES: PageSize[] = [10, 15, 25, 50, 100];

/**
 * «Сортування» (поле: «Немає» + поля; напрям: за зростанням / за спаданням) і «Нумерація сторінок» (10–100 на сторінці) — прототип v4;
 * поля з персональними даними — лише з `pii`.
 */
export function ViewSortEditor({ rt, sort, pageSize, paging, onSort, onPageSize, pii = true }: IViewSortEditorProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const field = sort.replace(/^-/, '');
  const desc = sort.startsWith('-');
  return (
    <>
      <div className="lv-vs__field">
        <span className="lv-vs__caption">{t('viewSettings.sorting')}</span>
        <div className="lv-vs__row">
          <select className="lv-select" value={field} aria-label={t('viewSettings.sortField')} onChange={(e) => onSort(e.target.value ? `${desc ? '-' : ''}${e.target.value}` : '')}>
            <option value="">{t('viewSettings.noSort')}</option>
            {rt.fields.filter((f) => f.type !== 'textarea' && f.type !== 'json' && !f.hidden && (pii || !f.pii)).map((f) => <option key={f.key} value={f.key}>{strings.field(rt.key, f.key, f.label)}</option>)}
          </select>
          <select className="lv-select" value={desc ? 'desc' : 'asc'} aria-label={t('viewSettings.sortDir')} disabled={!field}
            onChange={(e) => onSort(`${e.target.value === 'desc' ? '-' : ''}${field}`)}>
            <option value="asc">{t('viewSettings.asc')}</option>
            <option value="desc">{t('viewSettings.desc')}</option>
          </select>
        </div>
      </div>
      {paging && <div className="lv-vs__field">
        <span className="lv-vs__caption">{t('viewSettings.pagination')}</span>
        <select className="lv-select lv-vs__size" value={pageSize} aria-label={t('viewSettings.pagination')} onChange={(e) => onPageSize(Number(e.target.value) as PageSize)}>
          {SIZES.map((s) => <option key={s} value={s}>{t('listbar.perPage', { count: s })}</option>)}
        </select>
      </div>}
    </>
  );
}
